'use client';
import styled from 'styled-components';

export const StyledEmailFormContainer = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
`;
